import { render, staticRenderFns } from "./PDFClientes.vue?vue&type=template&id=10204b68&"
import script from "./PDFClientes.vue?vue&type=script&lang=js&"
export * from "./PDFClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports